<template>
  <div v-if="visible" class="form-input-list" style="position:relative;">
    <el-form-item
      v-for="(litem, lindex) in form[column.name]"
      :key="`${lindex}`"
      class="form form-input-list pos-relative"
      :label="(lindex === 0 || lindex === '0') ? column.label : undefined"
      :prop="column.name"
      :rules="rules[column.name]">

      <template slot="label">
        <span v-if="lindex === 0 || lindex === '0'" class="inline-middle">{{ column.label }}</span>

        <el-tooltip v-if="column.prefixInfo" effect="dark"
          placement="top"
          popper-class="tooltip-content">
          <div slot="content" v-html="column.prefixInfo.label"></div>
          <i class="header-icon el-icon-info tooltip-info-icon"></i>
        </el-tooltip>
      </template>

      <el-input
        :name="column.name"
        :type="column.inputType || 'text'"
        v-model="form[column.name][lindex]"
        :maxlength="column.maxlength || undefined"
        :disabled="disabled || false"
        :readonly="column.readonly || false"
        :autosize="column.autoSize || {}"
        :autoComplete="column.autoComplete || 'off'"
        :placeholder="column.placeholder || ''"
        @input="onInput(parseInt(lindex, 10), form[column.name] && form[column.name][lindex])">
      </el-input>

      <div style="position:absolute;right:-18px;top:0;"
        :style="((lindex === 0 || lindex === '0') && column.label != null) ? { top: '42px' } : {}"
        v-if="(form[column.name] && form[column.name].length > 1)">
        <a href="#" @click="$event.preventDefault();onDelete(parseInt(lindex, 10))">
          <i class="el-icon-error color-info"></i>
        </a>
      </div>
    </el-form-item>

    <el-form-item
      v-if="ruleRequireAtLeastOnce && (!form || !form[column.name] || form[column.name].length <= 0)"
      class="form form-input-list pos-relative"
      :label="column.label"
      :prop="column.name"
      :rules="rules[column.name]">
      <div class="el-form-item__error">
        Require at least one entry
      </div>
    </el-form-item>

    <a href="#" class="addNew"
      @click="$event.preventDefault();onAdd()" style="display:block;margin-top:0;margin-bottom:12px;"
      v-if="(!column.addNewHidden) && (column.hasOwnProperty('max') &&
        form[column.name].length < column.max)">
      {{ column.addNewLabel || '+ ADD ANOTHER' }}
    </a>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'form-input',
  components: {
  },
  props: ['column', 'form', 'data', 'rules', 'rule-require-at-least-once', 'disabled'],
  data () {
    return {
      visible: true,
      // dataInt: {}
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
  },
  watch: {
    data: function (value) {
      // console.log('data watcher', value)
      this.refresh()
    },
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
    },

    onInput (index, value) {
      let info = _.assign({}, this.column, { index, value })
      this.$emit('on-input', info)
    },

    onDelete (index) {
      let info = _.assign({}, this.column, { index })
      this.$emit('on-delete', info)
    },

    onAdd () {
      let info = _.assign({}, this.column)
      this.$emit('on-add', info)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-input-list {
  .el-input__inner {
    &[readonly=readonly] {
      background-color: #f5f7fa !important;
    }
  }

  .el-input-group__append button.el-button,
  .el-input-group__append div.el-select .el-input__inner,
  .el-input-group__append div.el-select:hover .el-input__inner,
  .el-input-group__prepend button.el-button,
  .el-input-group__prepend div.el-select .el-input__inner,
  .el-input-group__prepend div.el-select:hover .el-input__inner {
    background-color: transparent !important;
  }

  .addNew {
    color: $color-blue;
    text-decoration: underline;
    font-family: LatoBold;
  }
}

</style>
